import states from "../states";

const set = (key, variable) => {

    // console.log(key, variable)
    states.dispatch(key, JSON.stringify(variable));
}

const get = (key) => {
    return JSON.parse(states.getters[key])
}

const setField = (key_get, key_set, field, variable) => {
    let get_result = get(key_get);

    get_result[field] = variable;

    set(key_set, get_result);
}


const wipeStates = () => {
    set('config/setConfig', {});
    set('payment/setPayment', {});
    set('status/setStatus', {});
    set('token/setToken', false);
    set('transaction/setTransaction', {});
}

export {
    get,
    set,
    setField,
    wipeStates,
}
